<template>
	<layout-admin>
		<!--<h1>hallo user grid!</h1>-->

		<admin-crop-grid
			:title="title"
			:rows="data"
			:cols="cols"
			v-bind:row-href="rowHref"
			defaultOrderBy="id"
			:defaultOrderByAscending="true"
		/>
	</layout-admin>
</template>

<script>
let options = require("../../cropOptions");

export default {
	props: {
		data: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			title: this.__("Contracts"),
			cols: [
				{
					id: "id",
					name: "ID",
					render: (id) => "#" + id,
				},
				{
					id: "seller",
					name: this.__("Seller"),
					render: (x, row) => row.seller.company_name,
				},
				{
					id: "buyer",
					name: this.__("Buyer"),
					render: (x, row) => row.buyer.company_name,
				},
				{
					id: "product__grade",
					name: this.__("Article"),
					render: (grade) =>
						window.__(options.getLabel(grade, options.productGradeOptions)),
					filterOptions: Object.values(options.productGradeOptions)
						.flat()
						.map((o) => {
							return {
								id: this.__(o.name),
								name: this.__(o.name),
							};
						}),
				},
				{
					id: "product__harvest",
					name: this.__("Harvest"),
				},
				{
					id: "qty__mt",
					name: this.__("Quantity in t"),
					render: (x, row) => row.qty__mt * 1,
				},
				{
					id: "price__mt",
					name: this.__("Price €/t "),
					render: (x, row) => row.price__mt * 1,
				},
				{
					id: "location__desc",
					name: this.__("Location"),
				},
				{
					id: "date__desc",
					name: this.__("Fulfilment Date"),
				},
				{
					id: "created_at",
					name: this.__("Created"),
					render: options.formatIsoStamp,
				},
				{
					id: "confirm_url",
					name: "PDF",
					render: (x) => "PDF",
				},
				{
					id: "seller__type",
					name: this.__("Seller (type)"),
					render: (x, row) =>
						window.__(
							options.getLabel(row.seller.type, options.companyTypeOptions)
						),
				},
				{
					id: "buyer__type",
					name: this.__("Buyer (type)"),
					render: (x, row) =>
						window.__(
							options.getLabel(row.buyer.type, options.companyTypeOptions)
						),
				},
				{
					id: "seller__id",
					name: this.__("Seller (ID)"),
					render: (x, row) => row.seller.id,
				},
				{
					id: "buyer__id",
					name: this.__("Buyer (ID)"),
					render: (x, row) => row.buyer.id,
				},
			],
		};
	},
	methods: {
		rowHref(row) {
			return window.baseUrl + "/admin/contracts/" + row.id.replace("#", "");
		},
	},
};
</script>
